import { render, staticRenderFns } from "./PopupDefault.vue?vue&type=template&id=a09aede4&"
import script from "./PopupDefault.vue?vue&type=script&lang=js&"
export * from "./PopupDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports